import React, { useState, useEffect } from 'react'
import { Table, IconButton, Icon, Panel, ButtonGroup, Row, Col, Dropdown } from 'rsuite'
// import pathname from '../../constants/pathname'
// import { useHistory } from 'react-router-dom'
import { budgetFormat } from '../../utils/formatterUtil'
// import EditButton from '../../components/buttons/editButton/EditButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import TooltipButton from '../../components/buttons/TooltipButton'
import { maskIdCard } from '../../utils/dataUtil'

export default function ViewFileseFillingTable({ schema, data, loading, taxType, ...props }) {
  const { Column, HeaderCell, Cell } = Table
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [deleteObj, setDeleteObj] = useState({})
  console.log('data', data)
  return (
    <>
      <Table wordWrap autoHeight loading={loading} data={data || []}>
        {/* <Column width={80} align="center">
          <HeaderCell>ลำดับที่</HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1
            }}
          </Cell>
        </Column> */}

        {taxType == '1' && (
          <Column width={100}>
            <HeaderCell>เงินได้ตามมาตรา</HeaderCell>
            <Cell dataKey="incomeType" />
          </Column>
        )}

        <Column width={100}>
          <HeaderCell>ลำดับที่</HeaderCell>
          <Cell dataKey="runingSequenceNo" />
        </Column>
        <Column width={150}>
          <HeaderCell>เลขประจำตัวผู้เสียภาษี</HeaderCell>
          {/* <Cell dataKey="taxId" /> */}
          <Cell>
            {(rowData) => {
              return <>{maskIdCard(rowData.taxId)}</>
            }}
          </Cell>
        </Column>

        {taxType == '3' && (
          <Column width={100}>
            <HeaderCell>รหัสสาขา</HeaderCell>
            <Cell dataKey="branch" />
          </Column>
        )}

        {taxType == '3' && (
          <Column width={100}>
            <HeaderCell>ชื่อ</HeaderCell>
            <Cell dataKey="organizationName" />
          </Column>
        )}

        {(taxType == '1' || taxType == '2') && (
          <Column width={100}>
            <HeaderCell>คำนำหน้าชื่อ</HeaderCell>
            <Cell dataKey="title" />
          </Column>
        )}

        {(taxType == '1' || taxType == '2') && (
          <Column width={100}>
            <HeaderCell>ชื่อ</HeaderCell>
            <Cell dataKey="firstName" />
          </Column>
        )}

        {(taxType == '1' || taxType == '2') && (
          <Column width={100}>
            <HeaderCell>นามสกุล</HeaderCell>
            <Cell dataKey="lastName" />
          </Column>
        )}

        {(taxType == '2' || taxType == '3') && (
          <Column width={150}>
            <HeaderCell>ชื่ออาคาร</HeaderCell>
            <Cell dataKey="buildingName" />
          </Column>
        )}

        {(taxType == '2' || taxType == '3') && (
          <Column width={150}>
            <HeaderCell>ชื่อหมู่บ้าน</HeaderCell>
            <Cell dataKey="villageName" />
          </Column>
        )}
        {(taxType == '2' || taxType == '3') && (
          <Column width={150}>
            <HeaderCell>ห้องเลขที่</HeaderCell>
            <Cell dataKey="roomNumber" />
          </Column>
        )}
        {(taxType == '2' || taxType == '3') && (
          <Column width={100}>
            <HeaderCell>ชั้นที่</HeaderCell>
            <Cell dataKey="floor" />
          </Column>
        )}
        {(taxType == '2' || taxType == '3') && (
          <Column width={100}>
            <HeaderCell>หมู่บ้าน</HeaderCell>
            <Cell dataKey="village" />
          </Column>
        )}
        {(taxType == '2' || taxType == '3') && (
          <Column width={100}>
            <HeaderCell>เลขที่</HeaderCell>
            <Cell dataKey="numberOfAddress" />
          </Column>
        )}
        {(taxType == '2' || taxType == '3') && (
          <Column width={100}>
            <HeaderCell>หมู่ที่</HeaderCell>
            <Cell dataKey="moo" />
          </Column>
        )}
        {(taxType == '2' || taxType == '3') && (
          <Column width={100}>
            <HeaderCell>ตรอก/ซอย</HeaderCell>
            <Cell dataKey="box" />
          </Column>
        )}
        {(taxType == '2' || taxType == '3') && (
          <Column width={100}>
            <HeaderCell>แยก</HeaderCell>
            <Cell dataKey="section" />
          </Column>
        )}
        {(taxType == '2' || taxType == '3') && (
          <Column width={100}>
            <HeaderCell>ถนน</HeaderCell>
            <Cell dataKey="roadName" />
          </Column>
        )}
        {(taxType == '2' || taxType == '3') && (
          <Column width={100}>
            <HeaderCell>ตำบล/แขวง</HeaderCell>
            <Cell dataKey="subDistrict" />
          </Column>
        )}
        {(taxType == '2' || taxType == '3') && (
          <Column width={100}>
            <HeaderCell>อำเภอ/เขต</HeaderCell>
            <Cell dataKey="district" />
          </Column>
        )}
        {(taxType == '2' || taxType == '3') && (
          <Column width={100}>
            <HeaderCell>จังหวัด</HeaderCell>
            <Cell dataKey="province" />
          </Column>
        )}
        {(taxType == '2' || taxType == '3') && (
          <Column width={100}>
            <HeaderCell>รหัสไปรษณีย์</HeaderCell>
            <Cell dataKey="postCode" />
          </Column>
        )}

        <Column width={150}>
          <HeaderCell>วันเดือนปี ที่จ่าย 1</HeaderCell>
          <Cell dataKey="submitDay1" />
        </Column>

        {(taxType == '2' || taxType == '3') && (
          <Column width={150}>
            <HeaderCell>ประเภทเงินได้พึงประเมิน 1</HeaderCell>
            <Cell dataKey="taxType1" />
          </Column>
        )}

        {(taxType == '2' || taxType == '3') && (
          <Column width={150}>
            <HeaderCell>อัตราภาษีร้อยละ 1</HeaderCell>
            <Cell dataKey="taxPercentage1" />
          </Column>
        )}
        <Column width={150}>
          <HeaderCell>ฐานภาษีหัก ณ ที่จ่าย 1</HeaderCell>
          <Cell dataKey="taxBaseAmount1" />
        </Column>
        <Column width={150}>
          <HeaderCell>ยอดภาษีหัก ณ ที่จ่าย 1</HeaderCell>
          <Cell dataKey="taxAmount1" />
        </Column>
        <Column width={150}>
          <HeaderCell>เงื่อนไข 1</HeaderCell>
          <Cell dataKey="taxCondition1" />
        </Column>
        <Column width={150}>
          <HeaderCell>วันเดือนปี ที่จ่าย 2</HeaderCell>
          <Cell dataKey="submitDay2" />
        </Column>

        {(taxType == '2' || taxType == '3') && (
          <Column width={150}>
            <HeaderCell>ประเภทเงินได้พึงประเมิน 2</HeaderCell>
            <Cell dataKey="taxType2" />
          </Column>
        )}

        {(taxType == '2' || taxType == '3') && (
          <Column width={150}>
            <HeaderCell>อัตราภาษีร้อยละ 2</HeaderCell>
            <Cell dataKey="taxPercentage2" />
          </Column>
        )}
        <Column width={150}>
          <HeaderCell>ฐานภาษีหัก ณ ที่จ่าย 2</HeaderCell>
          <Cell dataKey="taxBaseAmount2" />
        </Column>
        <Column width={150}>
          <HeaderCell>ยอดภาษีหัก ณ ที่จ่าย 2</HeaderCell>
          <Cell dataKey="taxAmount2" />
        </Column>
        <Column width={150}>
          <HeaderCell>เงื่อนไข 2</HeaderCell>
          <Cell dataKey="taxCondition2" />
        </Column>
        <Column width={150}>
          <HeaderCell>วันเดือนปี ที่จ่าย 3</HeaderCell>
          <Cell dataKey="submitDay3" />
        </Column>

        {(taxType == '2' || taxType == '3') && (
          <Column width={150}>
            <HeaderCell>ประเภทเงินได้พึงประเมิน 3</HeaderCell>
            <Cell dataKey="taxType3" />
          </Column>
        )}

        {(taxType == '2' || taxType == '3') && (
          <Column width={150}>
            <HeaderCell>อัตราภาษีร้อยละ 3</HeaderCell>
            <Cell dataKey="taxPercentage3" />
          </Column>
        )}
        <Column width={150}>
          <HeaderCell>ฐานภาษีหัก ณ ที่จ่าย 3</HeaderCell>
          <Cell dataKey="taxBaseAmount3" />
        </Column>
        <Column width={150}>
          <HeaderCell>ยอดภาษีหัก ณ ที่จ่าย 3</HeaderCell>
          <Cell dataKey="taxAmount3" />
        </Column>
        <Column width={150}>
          <HeaderCell>เงื่อนไข 3</HeaderCell>
          <Cell dataKey="taxCondition3" />
        </Column>
        <Column width={150}>
          <HeaderCell>เลขที่เอกสารจ่าย</HeaderCell>
          <Cell dataKey="refDocementNumber" />
        </Column>
        <Column width={100}>
          <HeaderCell>ปี</HeaderCell>
          <Cell dataKey="physicalYear" />
        </Column>
      </Table>
    </>
  )
}
